import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import { toast } from 'react-toastify';

import Tabela from '~/Components/TabelaDinamica/Tabela';
import { importarDadosImovel, exportarDadosImovel } from '~/Services/Service';

const TabDadosImovel = ({ ativos, familia }) => {
  const fileInputRef = useRef(null);

  const handleExportar = async () => {
    try {
      const res = await exportarDadosImovel(familia);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'dados_imovel.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error('Erro ao exportar dados do imóvel');
    }
  };

  const handleImportar = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('familia', familia);
    try {
      const res = await importarDadosImovel(formData);
      toast.success(
        `${(res.data && res.data.atualizados) || 0} registros atualizados`
      );
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data) ||
        'Erro ao importar dados do imóvel';
      toast.error(msg);
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const colunas = [
    { title: 'Código', key: 'codigo_ativo', width: '80px' },
    { title: 'Nome', key: 'nome' },
    { title: 'Quadra', key: 'quadra', width: '80px' },
    { title: 'Lote', key: 'lote', width: '80px' },
    { title: 'Endereço', key: 'endereco' },
    { title: 'Matrícula', key: 'matricula', width: '100px' },
    { title: 'Cad. Água', key: 'cad_agua', width: '100px' },
    { title: 'Cad. Prefeitura', key: 'cad_prefeitura', width: '120px' },
    { title: 'Caucionado', key: 'caucionado', width: '90px' },
  ];

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls"
          style={{ display: 'none' }}
          onChange={handleImportar}
        />
        <Button
          variant="outline-success"
          size="sm"
          className="mr-2"
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          <FaFileExcel className="mr-1" /> Importar
        </Button>
        <Button
          variant="outline-success"
          size="sm"
          onClick={handleExportar}
        >
          <FaFileExcel className="mr-1" /> Exportar
        </Button>
      </div>

      <Tabela colunas={colunas} dados={ativos} />
    </>
  );
};

export default TabDadosImovel;
